import React, { createContext, useContext, useState } from 'react';

interface PaymentContextType {
  isInPaymentPhase: boolean;
  setIsInPaymentPhase: (isInPaymentPhase: boolean) => void;
}

const PaymentContext = createContext<PaymentContextType | undefined>(undefined);

export const PaymentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isInPaymentPhase, setIsInPaymentPhase] = useState(false);

  return (
    <PaymentContext.Provider value={{ isInPaymentPhase, setIsInPaymentPhase }}>
      {children}
    </PaymentContext.Provider>
  );
};

export const usePaymentContext = () => {
  const context = useContext(PaymentContext);
  if (context === undefined) {
    throw new Error('usePaymentContext must be used within a PaymentProvider');
  }
  return context;
};